import { render, staticRenderFns } from "./selectionInstance.vue?vue&type=template&id=2e210871&scoped=true"
import script from "./selectionInstance.vue?vue&type=script&lang=js"
export * from "./selectionInstance.vue?vue&type=script&lang=js"
import style0 from "./selectionInstance.vue?vue&type=style&index=0&id=2e210871&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e210871",
  null
  
)

export default component.exports